import React, {
  useContext,
  useRef,
  useCallback,
  useImperativeHandle,
} from 'react';
import classnames from 'clsx';
import type { ToolbarChildrenProps } from 'draft-js-inline-toolbar-plugin';
import { formatClassNames } from '@wix/editor-elements-common-utils';
import LinkModal from '../../../../../../RichTextBoxLinkModal/viewer/RichTextBoxLinkModal';
import styles from '../../button.scss';
import LinkIcon from '../LinkIcon';
import { hasEntity } from '../../../../utils/draftUtils';
import StylesContext from '../../../../StylesContext';
import semanticClassNames from '../../../../../RichTextBox.semanticClassNames';
import type { OpenModalRef } from '../../../../../RichTextBox.types';

export default (
  props: ToolbarChildrenProps & {
    linkModalButtonRef: React.RefObject<OpenModalRef>;
  },
) => {
  const { setEditorState, getEditorState, onOverrideContent } = props;
  const stylesContext = useContext(StylesContext);
  const linkButtonRef = useRef<HTMLDivElement>(null);

  const onClose = useCallback(() => {
    // @ts-expect-error
    onOverrideContent(undefined);
  }, [onOverrideContent]);

  const openLinkModal = useCallback(() => {
    const content = () => (
      <LinkModal
        getEditorState={getEditorState}
        setEditorState={setEditorState}
        onClose={onClose}
        linkButtonRef={linkButtonRef}
      />
    );
    onOverrideContent(content);
  }, [getEditorState, onOverrideContent, setEditorState, onClose]);

  useImperativeHandle(props.linkModalButtonRef, () => ({
    openModal: openLinkModal,
  }));

  const preventBubblingUp = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const selected = hasEntity(getEditorState(), 'LINK');
  return (
    <div className={styles.buttonContainer} ref={linkButtonRef}>
      <button
        className={classnames(styles.button, {
          [styles.hovered]: stylesContext.hovered,
          [styles.focused]: stylesContext.focused,
          [styles.error]: stylesContext.error,
        })}
        onMouseDown={preventBubblingUp}
        onClick={openLinkModal}
        type="button"
      >
        <div
          className={classnames(
            styles.buttonContent,
            formatClassNames(semanticClassNames.icons),
            selected && styles.buttonContentSelected,
          )}
        >
          <LinkIcon />
        </div>
      </button>
    </div>
  );
};
